/**
 * Desktop navigation arrows for the PDP main image.
 *
 * On desktop the gallery is not a Flickity carousel (Flickity runs with
 * `watchCSS` and is deactivated above 750px), so `carousel-slider.js` calling
 * `flickity.previous()/next()` is a no-op there. This module makes the same
 * prev/next buttons switch the active media via `media-gallery`'s own
 * `setActiveMedia()`, which also syncs the thumbnails and plays video/3D media.
 */
(() => {
  const INITIALISED = "cstmDesktopNavReady";

  function step(gallery, direction) {
    // Every rendered `.product-media-main` is navigable: on desktop the
    // inactive ones are `display: none`, and variant images excluded via
    // `hide_variants` are never rendered in the first place.
    const mains = [...gallery.querySelectorAll(".product-media-main")];

    if (mains.length < 2 || typeof gallery.setActiveMedia !== "function") {
      return;
    }

    const currentIndex = mains.findIndex((element) => element.classList.contains("is-active"));
    const nextIndex = (currentIndex + direction + mains.length) % mains.length;
    const nextMedia = mains[nextIndex];

    if (nextMedia && nextMedia.dataset.mediaId) {
      gallery.setActiveMedia(nextMedia.dataset.mediaId);
    }
  }

  function bind(navigation) {
    if (navigation[INITIALISED]) {
      return;
    }

    const gallery = document.querySelector(`#${navigation.getAttribute("for")}`);

    if (!gallery) {
      return;
    }

    navigation[INITIALISED] = true;

    const buttons = [
      [navigation.querySelector(".js-prev"), -1],
      [navigation.querySelector(".js-next"), 1],
    ];

    buttons.forEach(([button, direction]) => {
      if (!button) {
        return;
      }

      button.addEventListener("click", (event) => {
        // Mobile: Flickity is active and carousel-slider.js already handles it.
        if (gallery.flickity && gallery.flickity.isActive) {
          return;
        }

        event.preventDefault();
        step(gallery, direction);
      });
    });
  }

  function init(root = document) {
    root.querySelectorAll("carousel-navigation.cstm-gallery-nav--desktop").forEach(bind);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    init(event.target);
  });
})();
